export class FinancialStatementLoadProjection {
    static readonly type = '[FinancialStatement] Load Projection';
    constructor(public payload: { companyId: string; }) {}
}

export class FinancialStatementLoadCompanyOwed {
    static readonly type = '[FinancialStatement] Load Company Owed Amount';
    constructor(public payload: { companyId: string; }) {}
}
